import React from 'react';
import ComponentBox from 'components/BusinessLogic/Components/ComponentBox';
import { faPlane } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import ComponentSummary from 'components/BusinessLogic/Components/ComponentSummary';

function Flight({
    flight, dateLabel, showCommission, requestQuoteComponentId, requestQuoteId,
})
{
    const mainLeg = flight.requestFlightLegs && flight.requestFlightLegs.length > 0 ? flight.requestFlightLegs[0] : null;

    return (
        <ComponentBox
            requestQuoteComponentId={requestQuoteComponentId}
            requestQuoteId={requestQuoteId}
            date={dateLabel}
            typeName={`Flight ${mainLeg !== null ? ` - ${mainLeg.departure_time}` : ''}`}
            description={mainLeg !== null ? mainLeg.airline.name : ''}
            icon={faPlane}
            showViewMore={flight.requestFlightLegs && flight.requestFlightLegs.length > 1}
            summaryContent={(
                <ComponentSummary
                    showCommission={showCommission}
                    currency={flight.currency}
                    total={flight.total_price}
                    commission={parseFloat(flight.travel_agent_commissionable_amount) + parseFloat(flight.direct_travel_agent_commission_amount)}
                />
            )}
        >
            <div className="tw-px-3 tw-w-full tw-rounded-t-md tw-py-1 tw-mt-1  tw-h-[250px]" style={{ height: (flight.requestFlightLegs.length > 1 ? 'auto' : 195) }}>
                {mainLeg !== null && (
                    <div className="tw-flex tw-flex-row tw-flex-wrap">
                        {flight.requestFlightLegs && flight.requestFlightLegs.length > 0
                            && (flight.requestFlightLegs).map((leg, index) => (
                                <div key={leg.id} className={`tw-pb-2 tw-mb-2 tw-flex tw-flex-row tw-flex-wrap ${index + 1 !== flight.requestFlightLegs.length ? ' tw-border-b-2 tw-border-primary-default' : ''}`}>
                                    <span className="tw-w-full"><b>Airline: </b>{leg.airline.name}</span>
                                    <span className="tw-w-full"><b>From: </b>{`${leg.departureFromAirport.city}(${leg.departure_from})`} {leg.departure_date}, {leg.departure_time}</span>
                                    <span className="tw-w-full"><b>To: </b>{`${leg.departureToAirport.city}(${leg.departure_to})`} {leg.arrival_date}, {leg.arrival_time}</span>
                                    <span className="tw-w-full"><b>Record Locator: </b>{leg.flight_number}</span>
                                </div>
                            ))}
                    </div>
                )}
            </div>
        </ComponentBox>
    );
}

Flight.defaultProps = {
    dateLabel: null,
    showCommission: true,
};

Flight.propTypes = {
    requestQuoteComponentId: PropTypes.number,
    requestQuoteId: PropTypes.number,
    showCommission: PropTypes.bool,
    dateLabel: PropTypes.string,
    flight: PropTypes.shape(
        {
            total_price: PropTypes.number,
            travel_agent_commissionable_amount: PropTypes.any,
            direct_travel_agent_commission_amount: PropTypes.any,
            currency: PropTypes.shape({
                currency_change: PropTypes.number,
                code: PropTypes.string,
            }),
            requestFlightLegs: PropTypes.arrayOf(PropTypes.shape(
                {
                    airline: PropTypes.shape({
                        name: PropTypes.string,
                    }),
                    departureFromAirport: PropTypes.shape({
                        city: PropTypes.string,
                    }),
                    departureToAirport: PropTypes.shape({
                        city: PropTypes.string,
                    }),
                    total_price: PropTypes.number,
                    currency: PropTypes.shape({
                        currency_change: PropTypes.number,
                        code: PropTypes.string,
                    }),
                    departure_from: PropTypes.string,
                    departure_to: PropTypes.string,
                    arrival_date: PropTypes.string,
                    departure_date: PropTypes.string,
                    departure_time: PropTypes.string,
                    arrival_time: PropTypes.string,
                    flight_number: PropTypes.string,
                },
            )),
        },
    ),
};
export default Flight;
